<!--
 * @Author: DQL
 * @Date: 2020-03-18 09:58:31
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:35:22
 * @Description: file content
 -->
<template>
  <el-row
    v-loading="loading"
    type="flex"
    class="l-page l-page--nav page-dept"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :md="8"
      :span="10"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 左侧标题 -->
          <h2
            class="c-page__header-title"
          >
            组织树
          </h2>

          <!-- 左侧标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              type="primary"
              icon="kestrel-icon ki-plus"
              @click="handleDialog('addDept', {})"
            >
              新增根组织
            </el-button>
          </div>
          <!-- 左侧标题栏按钮区域 End -->
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <!-- TODO -->
              <!-- 树导航：过滤条件 Start -->
              <!--
              <div
                class="c-asideTree__param"
              >
                <el-input
                  v-model.trim="searchParam"
                  placeholder="机构部门名称"
                  class="c-asideTree__param-input"
                  @keyup.native.enter="filterDept"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click.prevent="filterDept"
                  />
                </el-input>
              </div> -->
              <!-- 树导航：过滤条件 End -->
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  v-if="!isShowTree"
                  ref="deptTree"
                  class="c-asideTree__tree o-tree-overflow--unset"
                  node-key="deptCode"
                  highlight-current
                  lazy
                  :load="handleLoadDeptTree"
                  :props="defaultProps"
                  :default-expanded-keys="defaultExpandedKeys"
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
            <!-- 树导航 End -->
            <div
              v-show="pageStatus=='editDept' && canNotLeavePage"
              class="js-cancle-edit"
              @click="handleClickCancleEdit()"
            />
          </hm-page-card>
        </div>
        <!-- 左侧导航主内容 End -->
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :md="16"
      :span="14"
    >
      <components
        :is="pageStatus"
        v-show="activeDept.deptCode"
        :dept-vo="deptVo"
        :can-not-leave-page.sync="canNotLeavePage"
        :is-loading.sync="loading"
        @switch="handleSwitchPageStatus"
        @reloadView="handleEditReloadDept"
        @delReload="handleDelReloadDept"
      />
    </el-col>
    <!-- 右侧主面板模块 End -->

    <!-- 新增机构 -->
    <add-dept-dialog
      v-if="showDialogName==='addDept'"
      :dl-params="dialogParams"
      @closeDialog="handleAddReloadDept"
    />
  </el-row>
</template>

<script>
import _ from 'lodash';
import { deptService } from './dept.service.js';

export default {
  name: 'DeptManage',
  components: {
    addDeptDialog: () => import('./addDeptDialog'),
    editDept: () => import('./editDept'),
    viewDept: () => import('./viewDept')
  },
  data () {
    return {
      initPage: true, // 页面首页加载初始化标识
      loading: false, // 页面loading状态

      /* 树组件配置 Start */
      isShowTree: false, // 是否显示树结构

      // 树组件默认参数配置
      defaultProps: {
        label: 'deptName',
        children: 'children',
        isLeaf: (data, node) => {
          return !data.xjbz;
        }
      },
      defaultExpandedKeys: [], // 树组件默认展开节点key
      selectedExpandeKeys: [], // 选中树节点的展开路径的节点key
      /* 树组件配置 End */

      // 当前选中的树节点（机构部门）
      activeDept: {
        deptCode: null,
        deptName: null
      },

      searchParam: null, // 筛选机构部门树参数
      deptVo: {}, // 当前选中机构部门详细信息
      pageStatus: null, // 页面状态：edit（编辑），view（查看）
      canNotLeavePage: false, // 处于编辑状态，不能离开
      reloadTreeBy: null, // 引起重新加载树结构的事件（edit，del，add）

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  methods: {
    /**
     * @description: 树组件异步请求
     * @param {*}
     * @return {*}
     */
    handleLoadDeptTree (node, resolve) {
      console.log('执行：异步加载机构树', node);
      this.loading = true;
      this.getDeptTree(node.data, resolve);
    },
    /**
     * @description: 加载机构树
     * @param {*}
     * @return {*}
     */
    getDeptTree (_data, _resolve) {
      const _this = this;
      const params = {};
      // 异步加载传入父节点key
      if (_data) {
        params.deptCode = _data.deptCode;
      }
      deptService.getTree(params)
        .then(rsp => {
          _resolve(rsp.data);
          _this.handleGetDeptTreeSuccess(rsp.data, _data);
        }).catch(err => {
          _this.loading = false;
          console.error('异步加载树失败', err);
        });
    },
    /**
     * @description: 异步树数据获取成功处理事件
     * @param {_parentData} 异步加载传入父节点key
     * @return {*}
     */
    handleGetDeptTreeSuccess (_treeData, _parentData) {
      const _this = this;
      if (_this.initPage) {
        // 初次加载页面，第一次异步加载数据，返回数据不为空，设置选中第一个根节点
        if (_treeData[0]) {
          _this.handleInitSetTree(_treeData);
        } else {
          _this.pageStatus = null;
          _this.loading = false;
        }
      } else if (_this.reloadTreeBy) {
        const lastAsyncLoadCode = _.clone(_this.defaultExpandedKeys).pop();
        // 操作引起的加载
        // 情况一：获取不到根节点
        if (!_parentData && !_treeData[0]) {
          _this.reloadTreeBy = null;
          _this.loading = false;
          _this.selectedExpandeKeys = [];
          _this.defaultExpandedKeys = [];
          _this.activeDept = {
            deptCode: null,
            deptName: null
          };
        } else if (_parentData && _parentData.deptCode !== lastAsyncLoadCode && !_treeData[0]) {
          // 情况二：根据上次操作的路径获取树，但是中途出现获取不到数据的路径；仅打开到此节点
          _this.reloadTreeBy = null;
          const errNodePath = _.takeWhile(_.clone(_this.defaultExpandedKeys), (o) => { return o !== _parentData.deptCode; });
          _this.selectedExpandeKeys = errNodePath;
          _this.defaultExpandedKeys = errNodePath;
          _this.activeDept = {
            deptCode: _parentData.deptCode,
            deptName: _parentData.deptName
          };
          _this.handleGetDept(_this.activeDept.deptCode);
          _this.$nextTick(() => {
            _this.$refs.deptTree.setCurrentKey(_this.activeDept.deptCode);
          });
        } else if (_parentData && _parentData.deptCode === lastAsyncLoadCode) {
          // 情况二：根据上次操作的路径获取树，完整获取数据
          _this.reloadTreeBy = null;
          _this.handleGetDept(_this.activeDept.deptCode);
          _this.$nextTick(() => {
            _this.$refs.deptTree.setCurrentKey(_this.activeDept.deptCode);
          });
        }
      } else {
        // 点击节点按钮加载树结构数据
        _this.loading = false;
      }
    },
    /**
     * @description: 树组件选中节点，获取节点信息信息以及节点路径
     * @param {*}
     * @return {*}
     */
    handleNodeClick (data, node) {
      this.pageStatus = 'viewDept';
      this.activeDept.deptCode = data.deptCode;
      this.activeDept.deptName = data.deptName;
      // 获取选中节点信息
      this.handleGetDept(data.deptCode);
      this.getTreeSelectedNodePath(data.deptCode);
    },
    /**
     * @description: 获取选中节点的展开路径节点key
     * @param {*}
     * @return {*}
     */
    getTreeSelectedNodePath (_deptCode) {
      if (!_deptCode) return;
      const _this = this;
      this.$nextTick(() => {
        const nodePath = this.$refs.deptTree.getNodePath(_deptCode);
        _this.selectedExpandeKeys = [];
        nodePath.forEach((node, index) => {
          _this.selectedExpandeKeys.push(node.deptCode);
        });
      });
    },
    /**
     * @description: 加载机构部门信息
     * @param {*}
     * @return {*}
     */
    handleGetDept (_deptCode) {
      const _this = this;
      _this.loading = true;
      deptService.get(_deptCode)
        .then(rsp => {
          _this.deptVo = rsp.data;
          _this.activeDept.deptName = rsp.data.deptName;
          _this.pageStatus = 'viewDept';
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 页面初次加载，默认选中根节点，显示根节点信息
     * @param {*}
     * @return {*}
     */
    handleInitSetTree (_treeData) {
      const _this = this;
      _this.activeDept.deptCode = _treeData[0].deptCode;
      _this.activeDept.deptName = _treeData[0].deptName;
      // 树结构默认展开keys
      _this.defaultExpandedKeys = [_treeData[0].deptCode];
      _this.selectedExpandeKeys = [_treeData[0].deptCode];
      _this.$refs.deptTree.setCurrentKey(_treeData[0].deptCode);
      _this.pageStatus = 'viewDept';
      _this.handleGetDept(_treeData[0].deptCode);
      _this.initPage = false;
    },
    /**
     * @description: 切换页面状态
     * @param {*}
     * @return {*}
     */
    handleSwitchPageStatus (_status) {
      if (_status === 'addDept') {
        this.showDialogName = 'addDept';
        this.dialogParams = {
          parentDeptCode: this.deptVo.deptCode,
          parentDeptName: this.deptVo.deptName
        };
      } else {
        this.pageStatus = _status;
      }
    },
    /**
     * @description: 编辑状态点击左侧树，提醒取消修改
     * @param {*}
     * @return {*}
     */
    handleClickCancleEdit () {
      const _this = this;
      this.$confirm('组织修改信息未保存，是否离开？', '提示', {
        type: 'warning'
      }).then(() => {
        _this.handleSwitchPageStatus('viewDept');
        _this.canNotLeavePage = false;
      });
    },
    /**
     * @description: 重新加载树结构（编辑更新成功、新增成功）
     * @param {*}
     * @return {*}
     */
    handleReloadTree () {
      const _this = this;
      _this.defaultExpandedKeys = _.clone(_this.selectedExpandeKeys);
      _this.loading = true;
      _this.isShowTree = true;
      console.log('重新加载页面', _this.defaultExpandedKeys);
      // 在页面dom删除完tree更新后再显示
      _this.$nextTick(() => {
        _this.isShowTree = false;
      });
    },
    /**
     * @description: 新增节点成功引起重新加载页面，查看新增的机构信息
     * @param {*}
     * @return {*}
     */
    handleAddReloadDept (_deptCode) {
      if (_deptCode && !this.dialogParams.parentDeptCode) {
        console.warn('根节点新增成功');
        this.selectedExpandeKeys = [_deptCode];
      }
      this.showDialogName = null;
      this.dialogParams = {};
      // 新增成功重载
      if (_deptCode) {
        this.activeDept.deptCode = _deptCode;
        this.selectedExpandeKeys = [..._.clone(this.selectedExpandeKeys), _deptCode];
        console.warn('新增成功引起重新加载页面', _deptCode);
        this.reloadTreeBy = 'add';
        this.handleReloadTree();
      }
    },
    /**
     * @description: 编辑更新引起重新加载页面
     * @param {*}
     * @return {*}
     */
    handleEditReloadDept () {
      if (this.selectedExpandeKeys.length > 1) {
        // 从选中展开节点中删除最后一个（即选中操作的节点）
        this.selectedExpandeKeys.pop();
      }
      console.warn('编辑更新引起重新加载页面', this.selectedExpandeKeys);
      this.reloadTreeBy = 'edit';
      this.handleReloadTree();
    },
    /**
     * @description: 删除引起重新加载页面
     * @param {*}
     * @return {*}
     */
    handleDelReloadDept () {
      // 从选中展开节点中删除最后一个（即选中操作的节点）
      this.selectedExpandeKeys.pop();
      // 更新选中节点为原选中的父节点，重载后展开
      if (this.selectedExpandeKeys.length > 1) {
        this.activeDept.deptCode = this.selectedExpandeKeys[this.selectedExpandeKeys.length - 1];
      } else {
        // 根节点删除，页面重新开始
        this.activeDept.deptCode = null;
        this.activeDept.deptName = null;
        this.initPage = true;
      }
      console.warn('删除引起重新加载页面');
      this.reloadTreeBy = 'del';
      this.handleReloadTree();
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    }
  }
};
</script>

<style scoped lang="scss">
.page-dept{
  .l-page--aside{
    position: relative;
  }
}

.js-cancle-edit{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

</style>
